<div> {{ name }} </div>
<div class="pt-2"><i> {{ drugNames }} </i></div>
